import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { RadioGroup as AriaRadioGroup } from 'react-aria-components';
import Text from '~/components/typographies/Text';
import useDataTestId from '~/hooks/useDataTestId';
import styles from './RadioGroup.module.scss';

interface Props {
  errorMessage?: string;
  defaultValue?: string;
  name?: string;
  onChange: (value: string) => void;
  otherInfo?: string;
  value?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  className?: string;
  dataTestId?: string;
}

const RadioGroup: React.FC<PropsWithChildren<Props>> = ({
  children,
  defaultValue,
  errorMessage,
  name,
  onChange,
  otherInfo,
  value,
  ariaLabel,
  ariaLabelledBy,
  className,
  dataTestId,
}) => {
  const dt = useDataTestId(dataTestId);
  return (
    <AriaRadioGroup
      onChange={onChange}
      defaultValue={defaultValue}
      name={name}
      value={value}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={clsx(styles.radiogroup, className)}
      data-testid={dt()}
    >
      {children}

      {otherInfo && (
        <Text variant="caption" weight="medium" secondaryColor>
          {otherInfo}
        </Text>
      )}
      {errorMessage && (
        <Text variant="caption" weight="medium" className={styles.errorMessage}>
          {errorMessage}
        </Text>
      )}
    </AriaRadioGroup>
  );
};

export default RadioGroup;
